import type { ReactNode } from 'react'
import { MarketingFooter } from './MarketingFooter'

export const SITE_FOOTER_COPYRIGHT = '© 2026 Sentio Ltd. All rights reserved.'

interface SiteFooterProps {
  /** Rendered before policy links on the second line (e.g. Home ·). */
  prefix?: ReactNode
  /** Optional content rendered after marketing footer links. */
  suffix?: ReactNode
}

export function SiteFooter({ prefix, suffix }: SiteFooterProps) {
  return (
    <div className="space-y-2 text-center text-xs text-text-muted">
      <p>{SITE_FOOTER_COPYRIGHT}</p>
      <p>
        {prefix}
        <MarketingFooter />
        {suffix}
      </p>
    </div>
  )
}
